import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, JhiLanguageService } from 'ng-jhipster';

import { ImageResource } from './image-resource.model';
import { ImageResourcePopupService } from './image-resource-popup.service';
import { ImageResourceService } from './image-resource.service';

@Component({
    selector: 'dcs-image-resource-delete-dialog',
    templateUrl: './image-resource-delete-dialog.component.html'
})
export class ImageResourceDeleteDialogComponent {

    imageResource: ImageResource;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private imageResourceService: ImageResourceService,
        public activeModal: NgbActiveModal,
        private eventManager: EventManager
    ) {
        this.jhiLanguageService.setLocations(['imageResource']);
    }

    clear () {
        this.activeModal.dismiss('cancel');
    }

    confirmDelete (id: number) {
        this.imageResourceService.delete(id).subscribe(response => {
            this.eventManager.broadcast({
                name: 'imageResourceListModification',
                content: 'Deleted an imageResource'
            });
            this.activeModal.dismiss(true);
        });
    }
}

@Component({
    selector: 'dcs-image-resource-delete-popup',
    template: ''
})
export class ImageResourceDeletePopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor (
        private route: ActivatedRoute,
        private imageResourcePopupService: ImageResourcePopupService
    ) {}

    ngOnInit() {
        this.routeSub = this.route.params.subscribe(params => {
            this.modalRef = this.imageResourcePopupService
                .open(ImageResourceDeleteDialogComponent, params['id']);
        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/image-resource/image-resource-delete-dialog.component.ts